export enum BannerColorTheme {
    Default = "variant-1",
    Variant2 = "variant-2",
}

export enum BannerContentPosition {
    Left = "left",
    Right = "right",
    Auto = "auto"
}

const BannerColorThemes = {
    [BannerColorTheme.Default]: {
        titleColor: "text-banner-text-color-variant-1",
        subtitleColor: "text-banner-subtitle-color-variant-1",
        backgroundColor: "bg-banner-bg-color-variant-1",
        textColor: "text-banner-text-color-variant-1",
        hrColor: "bg-banner-text-color-variant-1",
        buttonColor: "primary-light"
    },
    [BannerColorTheme.Variant2]: {
        titleColor: "text-banner-text-color-variant-2",
        subtitleColor: "text-banner-subtitle-color-variant-2",
        textColor: "text-banner-text-color-variant-2",
        backgroundColor: "bg-banner-bg-color-variant-2"
    }
};

export const getBannerColorTheme = (theme: BannerColorTheme) => ({
    ...BannerColorThemes[BannerColorTheme.Default],
    ...BannerColorThemes[theme]
});